import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_auction_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_auction_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_auction_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_36 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row" }
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_42 = {
  type: "submit",
  id: "kt_auction_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_43 = { class: "indicator-label" }
const _hoisted_44 = { class: "indicator-progress" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_46 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_47 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_auction_create_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_auction_create_attachments"
}
const _hoisted_48 = { class: "card-title m-0" }
const _hoisted_49 = { class: "fw-bolder m-0" }
const _hoisted_50 = {
  id: "kt_auction_create_attachments",
  class: "collapse show"
}
const _hoisted_51 = { class: "card-body border-top p-9" }
const _hoisted_52 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_53 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_54 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_55 = { class: "fw-bold" }
const _hoisted_56 = { class: "fs-6 text-gray-600" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8" }
const _hoisted_60 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_61 = {
  class: "image-input image-input-wrapper",
  "data-kt-image-input": "true"
}
const _hoisted_62 = ["data-video", "data-sub-html"]
const _hoisted_63 = ["src"]
const _hoisted_64 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_66 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "indicator-label" }
const _hoisted_69 = { class: "indicator-progress" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_lightgallery = _resolveComponent("lightgallery")!
  const _component_PropertiesListing = _resolveComponent("PropertiesListing")!
  const _component_PropertiesCreating = _resolveComponent("PropertiesCreating")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'auctions'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('auctionDetails')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.auctionsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate('organizer')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "organiserId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedOrganizer,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOrganizer) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('selectOrganizer')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizers, (organizer) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: organizer.id,
                              value: organizer.id
                            }, _toDisplayString(organizer.titleEn), 9, _hoisted_12))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "organiserId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('location')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "organisersLocationsId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedLocation,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLocation) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('selectLocation')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: location.id,
                              value: location.id
                            }, _toDisplayString(location.venue), 9, _hoisted_20))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "organisersLocationsId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate('dateAndTime')) + ": ", 1),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_Field, {
                        type: "datetime-local",
                        name: "eventDatetime",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid"
                      }),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "eventDatetime" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('loanRequest')) + ": ", 1),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          name: "loanRequest",
                          modelValue: _ctx.loanRequest,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loanRequest) = $event)),
                          type: "checkbox",
                          value: true,
                          checked: "checked"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('certifiedCheckRequest')) + ": ", 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          name: "certifiedCheckRequest",
                          type: "checkbox",
                          modelValue: _ctx.certifiedCheckRequest,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.certifiedCheckRequest) = $event)),
                          value: true,
                          checked: "checked"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  (_ctx.certifiedCheckRequest || _ctx.loanRequest)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('expiryBanner')) + ": ", 1),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_Field, {
                            type: "datetime-local",
                            name: "expiryBanner",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid"
                          }),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createVNode(_component_ErrorMessage, { name: "expiryBanner" })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.createdAuction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _createElementVNode("button", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_44, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_45
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'auctions'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("h3", _hoisted_49, _toDisplayString(_ctx.translate('auctionAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              (!_ctx.createdAuction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("span", _hoisted_53, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.translate('savingAuctionAttachmentNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('video')) + ": ", 1),
                _createElementVNode("div", _hoisted_59, [
                  (!_ctx.videoInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createVNode(_component_Field, {
                          type: "file",
                          accept: "video/*",
                          name: "",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('auctionVideo'),
                          modelValue: _ctx.videoInput,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.videoInput) = $event)),
                          onChange: _ctx.previewVideo
                        }, null, 8, ["placeholder", "modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        onInit: _ctx.onInit,
                        onBeforeSlide: _ctx.updateSlides,
                        "data-poster": "",
                        settings: { download: false, speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "data-video": `{"source": [{"src":"${_ctx.guideVideo}", "type":"video/mp4"}], "attributes": {"dynamic": false, "controls": true}}`,
                            "data-sub-html": `<h4>Auction video - <a href='https://alhisba.com/' >alhisba.com </a></h4> <p> - video- </a></p>`
                          }, [
                            _createElementVNode("video", {
                              class: "image-input-wrapper d-inline-block w-auto h-200px overflow-hidden",
                              role: "button",
                              src: _ctx.guideVideo
                            }, null, 8, _hoisted_63)
                          ], 8, _hoisted_62)
                        ]),
                        _: 1
                      }, 8, ["onInit", "onBeforeSlide", "settings"])
                    ]),
                    _createElementVNode("label", _hoisted_64, [
                      _hoisted_65,
                      _createVNode(_component_Field, {
                        type: "file",
                        accept: "video/*",
                        name: "",
                        autocomplete: "off",
                        placeholder: _ctx.translate('auctionVideo'),
                        filename: "guideVideo",
                        modelValue: _ctx.videoInput,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.videoInput) = $event)),
                        onChange: _ctx.previewVideo
                      }, null, 8, ["placeholder", "modelValue", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.videoInput]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_auction_create_attachments_submit",
                ref: "submitVideoButton",
                class: "btn btn-primary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmitVideo && _ctx.onSubmitVideo(...args))),
                disabled: !_ctx.createdAuction || !_ctx.videoInput
              }, [
                _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_69, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_70
                ])
              ], 8, _hoisted_67)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PropertiesListing, { "created-auction": _ctx.createdAuction }, null, 8, ["created-auction"]),
    (_ctx.createdAuction)
      ? (_openBlock(), _createBlock(_component_PropertiesCreating, {
          key: 2,
          "auction-id": _ctx.createdAuction.id
        }, null, 8, ["auction-id"]))
      : _createCommentVNode("", true)
  ], 64))
}